import React, { useState, useEffect, useRef } from "react";
import ReportingTable from "../ReportingTable/ReportingTable";
import "./TableContainer.scss";
import {
  ListSummarybyUserJSON,
  ListTransactionSummarybyUser,
  ListDetailbyUserJSON,
  AdminListSummarybyUserJSON,
  ATMListSummarybyUserJSON,
  ViewAllOperators,
  ATMListDetailbyUserJSON
} from "../../util/API/reporting";
import { useDispatch } from "react-redux";
import { setSummaryList } from "../../store/redux/reportingTable";
import { Box, IconButton } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import LoadingPage from "../UI/LoadingPage/LoadingPage";
import format from "date-fns/format";
import { setAsArray } from "../../util/utilfunctions/utilFunctions";

function TableContainer({ 
  thisduration, 
  showDetails, 
  handleDetailSwitch, 
  clearFilter,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  isAdmin,
  userID,
  filter,
  setFilter,
  transactionType,
  setTransactionType,
  options,
  currency,
  setCurrency,
  isOperator,
  fetchSummary, 
  setFetchSummary,
  reportType
}) {
  const [fullReportingDetails, setFullReportingDetails] = useState();
  const [transactionHistory, setTransactionHistory] = useState();
  const [hasData, setHasData] = useState(true);
  const [loading, setLoading] = useState(true);



  let parentuserid = sessionStorage.getItem("parentuserid");

  const dispatch = useDispatch();

  let data = JSON.parse(sessionStorage.getItem("user"));

  useEffect(() => {
    fetchSummaryData();
  }, [fetchSummary]);



  const formatToISODate = (rawDate) => {
  if (!rawDate) return "";
  const date = new Date(rawDate); // handles "2025-4-1" just fine
  return format(date, "yyyy-MM-dd"); // ensures "2025-04-01"
};

  const fetchSummaryData = async () => {
    setLoading(true);
    console.log("transactiontype===========", transactionType);
  console.log("reportType===========", reportType);
  console.log("filter===========", filter);
  
    let apiCall;
    if(reportType == "ATM" && isAdmin === "true") {
      apiCall = ATMListSummarybyUserJSON;
    } else if (isAdmin === "true") {
      apiCall = AdminListSummarybyUserJSON;
    } else if (isOperator === "true") {
      apiCall = ListTransactionSummarybyUser;
    } else {
      apiCall = ListSummarybyUserJSON;
    }
  
    try {
      const response = await apiCall(
        data.payload.body['User'].id,
        thisduration,
        isAdmin,
        startDate || "",
        endDate || "",
        filter.user,
        filter.type,
        true
      );

      console.log("apiCall_response-----------",response);

      if (thisduration === "3") {
        setStartDate(formatToISODate(response?.startdate));
        setEndDate(formatToISODate(response?.enddate));
      }
      else {
        setStartDate(response?.startdate);
        setEndDate(response?.enddate);
      }
      
      if (response && (response?.callStatus == 1)) {
        if (response?.payload) {
          dispatch(setSummaryList({ summary: response?.payload?.record }));
          if (response?.payload?.record?.length) {
            setTransactionHistory(response?.payload?.record);
            setHasData(true);
          } else {
            console.log("ELSE--------",response?.payload?.record);
            setTransactionHistory([response?.payload?.record]);
            setHasData(true);
          }
        } else {
          setHasData(false);
        }
      } else {
        setTransactionHistory([]);
      }
      console.log("test--------",response?.payload?.record);
    } catch (error) {
      console.error("Error fetching reporting details:", error);
      setHasData(false);
    } finally {
      setLoading(false);
      setFetchSummary(false);
    }
  };
  
  const getTransactionTypeDetail = async (transType, currency) => {
    console.log(transType, currency);
    setLoading(true);
  
    let responsePromises = [];
  
    if (isOperator === "true") {
      responsePromises.push(
        ViewAllOperators(
          thisduration,
          startDate,
          endDate,
          userID
        )
      );
    } else {
      console.log(currency, "tablecontainer");
      if(reportType == "ATM") {
        responsePromises.push(
          ATMListDetailbyUserJSON(
            thisduration,
            transType,
            startDate,
            endDate,
            currency,
            isAdmin,
            userID,
            filter.user
          )
        );
      } else {
        responsePromises.push(
          ListDetailbyUserJSON(
            thisduration,
            transType,
            startDate,
            endDate,
            currency,
            isAdmin,
            userID,
            filter.user
          )
        );
      }
    }
  
    try {
      const [response] = await Promise.all(responsePromises);

  console.log("getTransactionTypeDetail-----------", response);
      if (response) {
        let records = response?.payload?.record;
        records = response?.payload?.record;

        records = setAsArray(records);
        setFullReportingDetails(records);
        
        if (records?.length === 0) {
          setHasData(false);
        }
      }
    } catch (error) {
      console.error("Error fetching transaction details:", error);
    }
  
    setLoading(false);
  };

  return (
    <Box>
      {loading ? (
        <LoadingPage />
      ) :
        <>
          {showDetails && 
            <Box>
              <IconButton>
                <ArrowBack 
                  onClick={() => 
                  {
                    setTransactionHistory();
                    fetchSummaryData();
                    handleDetailSwitch(); 
                    setFilter({...filter, viewAll: false})
                  }} 
                />
              </IconButton>
            </Box>
          }
        <ReportingTable
          handleDetailSwitch={handleDetailSwitch}
          reportingDetails={fullReportingDetails}
          getTransactionTypeDetail={getTransactionTypeDetail}
          transactionHistory={transactionHistory}
          hasData={hasData}
          thisduration={thisduration}
          showDetails={showDetails}
          isAdmin={isAdmin}
          clearFilter={clearFilter}
          filter={filter}
          setFilter={setFilter}
          startDate={startDate}
          endDate={endDate}
          setFullReportingDetails={setFullReportingDetails}
          userID={userID}
          transactionType={transactionType}
          setTransactionType={setTransactionType}
          options={options}
          currency={currency}
          setCurrency={setCurrency}
          isOperator={isOperator}
          reportType={reportType}
        />
        </>
      }
    </Box>
  );
}

export default TableContainer;
